import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/** An option whose label is a translation key, so it can be defined outside a component. */
export type TranslatableOption<T> = {
  labelKey: string;
  value: T;
  disabled?: boolean;
};

/**
 * @description Translates the labels of a static options list inside the component, so they
 * follow the current language instead of being fixed when the module is first imported.
 */
export const useTranslatedOptions = <T>(options: readonly TranslatableOption<T>[]) => {
  const { t } = useTranslation();

  return useMemo(
    () => options.map(({ labelKey, ...option }) => ({ ...option, label: t(labelKey) })),
    [options, t],
  );
};
